export async function playAudio(audio: HTMLAudioElement) {
  try {
    await audio.play();
  } catch {
    // sound cannot be played on iOS if no user interaction was done
    // we don't care as much if this happens
  }
}
